export const SEVERITY_TONE = {
  critical: "bg-red-500/20 text-red-200 border-red-500/40",
  warning: "bg-amber-500/20 text-amber-100 border-amber-500/35",
  info: "bg-sky-500/15 text-sky-100 border-sky-500/30",
};

const SEVERITY_RANK = { critical: 0, warning: 1, info: 2 };

export function notificationBucket(timestamp) {
  const date = new Date(timestamp);
  if (Number.isNaN(date.getTime())) return "Previous 7 days";
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
  const day = new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
  const diffDays = Math.round((today - day) / 86400000);
  if (diffDays === 0) return "Today";
  if (diffDays === 1) return "Yesterday";
  return "Previous 7 days";
}

export function sortNotifications(items = []) {
  return [...items].sort((a, b) => {
    if (Boolean(a.read) !== Boolean(b.read)) return a.read ? 1 : -1;
    const severity = (SEVERITY_RANK[a.severity] ?? 2) - (SEVERITY_RANK[b.severity] ?? 2);
    if (severity !== 0) return severity;
    return new Date(b.timestamp || 0).getTime() - new Date(a.timestamp || 0).getTime();
  });
}

export function groupNotifications(items = []) {
  return sortNotifications(items).reduce((acc, item) => {
    const bucket = notificationBucket(item.timestamp);
    acc[bucket] = acc[bucket] || [];
    acc[bucket].push(item);
    return acc;
  }, { Today: [], Yesterday: [], "Previous 7 days": [] });
}
